import React from 'react';
import { CircularProgress } from '@mui/material';
import { Button } from 'new/elements/Button';
import classes from './CodeEditorModeFooter.module.scss';

export interface CodeEditorModeFooterProps {
  isLoading?: boolean;
  cancelable?: boolean;
  isJsonValid?: boolean;
  onOpenSwitchModeDialog: () => void;
  onClose?: () => void;
  onSave: () => void;
}

export const CodeEditorModeFooter = (props: CodeEditorModeFooterProps) => {
  const { isLoading, isJsonValid = true, onOpenSwitchModeDialog, onClose, onSave } = props;

  return (
    <div className={classes.modalFooter}>
      <div className={classes.actionsRow}>
        {isLoading ? (
          <CircularProgress
            color="primary"
            size={22}
            thickness={5}
            disableShrink={true}
            className={classes.loadingProgress}
          />
        ) : (
          <>
            {props.cancelable ? null : (
              <Button
                data-testid="switch-ui-mode"
                onClick={onOpenSwitchModeDialog}
                variant="outlined"
                color="basic"
              >
                Switch to Form Mode
              </Button>
            )}

            <Button data-testid="cancel-ui-code" onClick={onClose} variant="outlined" color="basic">
              Cancel
            </Button>
            <Button
              data-testid="save-ui-code"
              onClick={onSave}
              variant="contained"
              color="error"
              className={classes.saveDanger}
              disabled={!isJsonValid}
            >
              Save
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
